import { FC, memo, useReducer } from 'react'
import { useMaasOidcIdToken } from '@maas-tools/auth-oidc'
import { Header, Menu, Seller, Service } from '@shell-components/core'
import { Link } from 'react-router-dom'
import { ReactComponent as Logo } from 'assets/images/universoMagaluLogo.svg'
import { useLogout } from 'common/infra/logout'
import { sendClickEvent } from 'common/utils/data-layer'
import UserInfoAction from 'components/UserInfoAction'
import { TMenuItem } from 'containers/App/appLayoutTypes'
import { useMenuItems } from 'hooks/use-menu'
import useLeadsAccountSellers from 'hooks/useLeadsAccountSellers'

interface IProps {
  children: React.ReactNode
}

export type TMenuResponse = {
  data: TMenuItem[]
}

const PrivateRouteLayout: FC<IProps> = ({ children }) => {
  const { idTokenPayload } = useMaasOidcIdToken()
  const logout = useLogout()
  const { concatenatedArray, accountMenu, sellerPermissions, currentSeller } =
    useLeadsAccountSellers()

  const menuFiltered = useMenuItems({ currentSeller, menu: accountMenu, sellerPermissions })

  const [isOpenMenu, onOpenMenu] = useReducer(bool => !bool, false)

  const hasServices = currentSeller?.accountServices
    ? currentSeller?.accountServices?.length > 0
    : false

  const handleLogout = async () => {
    sendClickEvent('menu-superior', 'click', 'menu:logout')
    await logout()
  }

  return (
    <>
      <Header
        enableSearchField={hasServices}
        enableMenuButton={hasServices}
        services={menuFiltered as Service[]}
        name={idTokenPayload?.name || ''}
        email={idTokenPayload?.email || ''}
        currentSeller={currentSeller as Seller}
        sellers={concatenatedArray as Seller[]}
        onLogout={handleLogout}
        onClickMenu={onOpenMenu}
        AfterUserInfoComponent={UserInfoAction}
        logo={<Logo />}
        RouterLink={Link}
      />
      <Menu
        services={menuFiltered as Service[]}
        open={isOpenMenu}
        onClose={onOpenMenu}
        mktUrl="https://marketplace.integracommerce.com.br"
        RouterLink={Link}
      />
      {children}
    </>
  )
}

export default memo(PrivateRouteLayout)
